import useAppModernisation from "../../hooks/useAppModernisation";
import EnhancedSearchResultsPage from "./EnhancedSearchResultsPage";
import ModernEnhancedSearchResultsPage from "./MordenEnhancedSearchResultsPage";

const EnhancedSearchResultsPageRouter = () => {
  const { isWebModernisationEnabled, isCalculatorsLegacyIntegration } = useAppModernisation();
  
  // For Drop 2 (hybrid mode), use legacy search layout even if web modernisation is enabled
  // Only use modern search layout in Drop 3 (full modernisation without legacy integration)
  const shouldUseLegacyLayout = isCalculatorsLegacyIntegration || !isWebModernisationEnabled;
  
  return shouldUseLegacyLayout ? (
    <EnhancedSearchResultsPage />
  ) : (
    <ModernEnhancedSearchResultsPage />
  );
};

export default EnhancedSearchResultsPageRouter;
